// extracted by mini-css-extract-plugin
export var card = "_n5-0";
export var content = "_n5-2";
export var icon = "_n5-1";